import { spaceTypes } from "redux/Ldb/types/spaceTypes";

const initialState = {
    // Single space
    fetchingSingleSpace: false,
    fetchedSingleSpaceSuccess: null,
    fetchedSingleSpaceFailure: null,

    // Spaces list
    fetchingSpaces: false,
    fetchedSpacesSuccess: null,
    fetchedSpacesFailure: null,

    // Create space
    creatingSpace: false,
    createdSpaceSuccess: null,
    createdSpaceFailure: null,

    // Update space
    updatingSpace: false,
    updatedSpaceSuccess: null,
    updatedSpaceFailure: null,

    // Delete space
    deletingSpace: false,
    deletedSpaceSuccess: null,
    deletedSpaceFailure: null,

    // Pin space
    pinningSpace: false,
    pinnedSpaceSuccess: null,
    pinnedSpaceFailure: null,

    // Unpin space
    unpinningSpace: false,
    unpinnedSpaceSuccess: null,
    unpinnedSpaceFailure: null,

    // Archive space
    archivingSpace: false,
    archivedSpaceSuccess: null,
    archivedSpaceFailure: null,

    // Unarchive space
    unarchivingSpace: false,
    unarchivedSpaceSuccess: null,
    unarchivedSpaceFailure: null,

    // Add space members
    addingSpaceMembers: false,
    addedSpaceMembersSuccess: null,
    addedSpaceMembersFailure: null,

    // Remove space member
    removingSpaceMember: false,
    removedSpaceMemberSuccess: null,
    removedSpaceMemberFailure: null,

    // Add space guests
    addingSpaceGuests: false,
    addedSpaceGuestsSuccess: null,
    addedSpaceGuestsFailure: null,

    // Remove space guest
    removingSpaceGuest: false,
    removedSpaceGuestSuccess: null,
    removedSpaceGuestFailure: null,

    // Space guest accept
    spaceGuestAccepting: false,
    spaceGuestAcceptedSuccess: null,
    spaceGuestAcceptedFailure: null,

    // Space guest login
    spaceGuestLoggingIn: false,
    spaceGuestLoggedInSuccess: null,
    spaceGuestLoggedInFailure: null,

    // Space guest token verify
    spaceGuestTokenVerifying: false,
    spaceGuestTokenVerifiedSuccess: null,
    spaceGuestTokenVerifiedFailure: null,

    // Get space guest invite preview
    gettingSpaceGuestInvitePreview: false,
    gotSpaceGuestInvitePreviewSuccess: null,
    gotSpaceGuestInvitePreviewFailure: null,

    // Get space guest brands
    gettingSpaceGuestBrands: false,
    gotSpaceGuestBrandsSuccess: null,
    gotSpaceGuestBrandsFailure: null,

    // Leave space
    leavingSpace: false,
    leftSpaceSuccess: null,
    leftSpaceFailure: null,

    // Space Messages
    // Fetch space messages
    fetchingSpaceMessages: false,
    fetchedSpaceMessagesSuccess: null,
    fetchedSpaceMessagesFailure: null,

    // Send space message
    sendingSpaceMessage: false,
    sentSpaceMessageSuccess: null,
    sentSpaceMessageFailure: null,

    // Pin space message
    pinningSpaceMessage: false,
    pinnedSpaceMessageSuccess: null,
    pinnedSpaceMessageFailure: null,

    // Unpin space message
    unpinningSpaceMessage: false,
    unpinnedSpaceMessageSuccess: null,
    unpinnedSpaceMessageFailure: null,

    // Edit space message
    editingSpaceMessage: false,
    editedSpaceMessageSuccess: null,
    editedSpaceMessageFailure: null,

    // Delete space message
    deletingSpaceMessage: false,
    deletedSpaceMessageSuccess: null,
    deletedSpaceMessageFailure: null,
    creatingSpaceFile: false,
    createSpaceFileSuccess: null,
    createSpaceFileFailure: null,
    gettingSpaceFiles: false,
    getSpaceFilesSuccess: null,
    getSpaceFilesFailure: null,
    deletingSpaceFile: false,
    deleteSpaceFileSuccess: null,
    deleteSpaceFileFailure: null,
    gettingSingleSpaceFile: false,
    getSingleSpaceFileSuccess: null,
    getSingleSpaceFileFailure: null,
    creatingSpaceNote: false,
    createSpaceNoteSuccess: null,
    createSpaceNoteFailure: null,
    updatingSpaceNote: false,
    updateSpaceNoteSuccess: null,
    updateSpaceNoteFailure: null,
    fetchingSpaceNotes: false,
    fetchSpaceNotesSuccess: null,
    fetchSpaceNotesFailure: null,
    fetchingSingleSpaceNote: false,
    fetchSingleSpaceNoteSuccess: null,
    fetchSingleSpaceNoteFailure: null,
    deletingSpaceNote: false,
    deleteSpaceNoteSuccess: null,
    deleteSpaceNoteFailure: null,
    pinningSpaceNote: false,
    pinSpaceNoteSuccess: null,
    pinSpaceNoteFailure: null,
    unpinningSpaceNote: false,
    unpinSpaceNoteSuccess: null,
    unpinSpaceNoteFailure: null,

    // Space Tasks
    fetchingSpaceTasks: false,
    fetchedSpaceTasksSuccess: null,
    fetchedSpaceTasksFailure: null,
    fetchingSingleSpaceTask: false,
    fetchedSingleSpaceTaskSuccess: null,
    fetchedSingleSpaceTaskFailure: null,
    creatingSpaceTask: false,
    createdSpaceTaskSuccess: null,
    createdSpaceTaskFailure: null,
    updatingSpaceTask: false,
    updatedSpaceTaskSuccess: null,
    updatedSpaceTaskFailure: null,
    deletingSpaceTask: false,
    deletedSpaceTaskSuccess: null,
    deletedSpaceTaskFailure: null,
    fetchingSpaceTasksRuns: false,
    fetchedSpaceTasksRunsSuccess: null,
    fetchedSpaceTasksRunsFailure: null,
    fetchingSpaceUnreadCount: false,
    fetchedSpaceUnreadCountSuccess: null,
    fetchedSpaceUnreadCountFailure: null,
};

export const space = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        // Single space
        case spaceTypes.FETCH_SINGLE_SPACE_REQUEST:
            return {
                ...state,
                fetchingSingleSpace: true,
                fetchedSingleSpaceSuccess: null,
                fetchedSingleSpaceFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_SUCCESS:
            return {
                ...state,
                fetchingSingleSpace: false,
                fetchedSingleSpaceSuccess: action.payload,
                fetchedSingleSpaceFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_FAILURE:
            return {
                ...state,
                fetchingSingleSpace: false,
                fetchedSingleSpaceSuccess: null,
                fetchedSingleSpaceFailure: action.payload,
            };

        // Spaces list
        case spaceTypes.FETCH_SPACES_REQUEST:
            return {
                ...state,
                fetchingSpaces: true,
                fetchedSpacesSuccess: null,
                fetchedSpacesFailure: null,
            };
        case spaceTypes.FETCH_SPACES_SUCCESS:
            return {
                ...state,
                fetchingSpaces: false,
                fetchedSpacesSuccess: action.payload,
                fetchedSpacesFailure: null,
            };
        case spaceTypes.FETCH_SPACES_FAILURE:
            return {
                ...state,
                fetchingSpaces: false,
                fetchedSpacesSuccess: null,
                fetchedSpacesFailure: action.payload,
            };

        // Create space
        case spaceTypes.CREATE_SPACE_REQUEST:
            return {
                ...state,
                creatingSpace: true,
                createdSpaceSuccess: null,
                createdSpaceFailure: null,
            };
        case spaceTypes.CREATE_SPACE_SUCCESS:
            return {
                ...state,
                creatingSpace: false,
                createdSpaceSuccess: action.payload,
                createdSpaceFailure: null,
            };
        case spaceTypes.CREATE_SPACE_FAILURE:
            return {
                ...state,
                creatingSpace: false,
                createdSpaceSuccess: null,
                createdSpaceFailure: action.payload,
            };

        // Update space
        case spaceTypes.UPDATE_SPACE_REQUEST:
            return {
                ...state,
                updatingSpace: true,
                updatedSpaceSuccess: null,
                updatedSpaceFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_SUCCESS:
            return {
                ...state,
                updatingSpace: false,
                updatedSpaceSuccess: action.payload,
                updatedSpaceFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_FAILURE:
            return {
                ...state,
                updatingSpace: false,
                updatedSpaceSuccess: null,
                updatedSpaceFailure: action.payload,
            };

        // Delete space
        case spaceTypes.DELETE_SPACE_REQUEST:
            return {
                ...state,
                deletingSpace: true,
                deletedSpaceSuccess: null,
                deletedSpaceFailure: null,
            };
        case spaceTypes.DELETE_SPACE_SUCCESS:
            return {
                ...state,
                deletingSpace: false,
                deletedSpaceSuccess: action.payload,
                deletedSpaceFailure: null,
            };
        case spaceTypes.DELETE_SPACE_FAILURE:
            return {
                ...state,
                deletingSpace: false,
                deletedSpaceSuccess: null,
                deletedSpaceFailure: action.payload,
            };

        // Pin space
        case spaceTypes.PIN_SPACE_REQUEST:
            return {
                ...state,
                pinningSpace: true,
                pinnedSpaceSuccess: null,
                pinnedSpaceFailure: null,
            };
        case spaceTypes.PIN_SPACE_SUCCESS:
            return {
                ...state,
                pinningSpace: false,
                pinnedSpaceSuccess: action.payload,
                pinnedSpaceFailure: null,
            };
        case spaceTypes.PIN_SPACE_FAILURE:
            return {
                ...state,
                pinningSpace: false,
                pinnedSpaceSuccess: null,
                pinnedSpaceFailure: action.payload,
            };

        // Unpin space
        case spaceTypes.UNPIN_SPACE_REQUEST:
            return {
                ...state,
                unpinningSpace: true,
                unpinnedSpaceSuccess: null,
                unpinnedSpaceFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_SUCCESS:
            return {
                ...state,
                unpinningSpace: false,
                unpinnedSpaceSuccess: action.payload,
                unpinnedSpaceFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_FAILURE:
            return {
                ...state,
                unpinningSpace: false,
                unpinnedSpaceSuccess: null,
                unpinnedSpaceFailure: action.payload,
            };

        // Archive space
        case spaceTypes.ARCHIVE_SPACE_REQUEST:
            return {
                ...state,
                archivingSpace: true,
                archivedSpaceSuccess: null,
                archivedSpaceFailure: null,
            };
        case spaceTypes.ARCHIVE_SPACE_SUCCESS:
            return {
                ...state,
                archivingSpace: false,
                archivedSpaceSuccess: action.payload,
                archivedSpaceFailure: null,
            };
        case spaceTypes.ARCHIVE_SPACE_FAILURE:
            return {
                ...state,
                archivingSpace: false,
                archivedSpaceSuccess: null,
                archivedSpaceFailure: action.payload,
            };

        // Unarchive space
        case spaceTypes.UNARCHIVE_SPACE_REQUEST:
            return {
                ...state,
                unarchivingSpace: true,
                unarchivedSpaceSuccess: null,
                unarchivedSpaceFailure: null,
            };
        case spaceTypes.UNARCHIVE_SPACE_SUCCESS:
            return {
                ...state,
                unarchivingSpace: false,
                unarchivedSpaceSuccess: action.payload,
                unarchivedSpaceFailure: null,
            };
        case spaceTypes.UNARCHIVE_SPACE_FAILURE:
            return {
                ...state,
                unarchivingSpace: false,
                unarchivedSpaceSuccess: null,
                unarchivedSpaceFailure: action.payload,
            };

        // Add space members
        case spaceTypes.ADD_SPACE_MEMBERS_REQUEST:
            return {
                ...state,
                addingSpaceMembers: true,
                addedSpaceMembersSuccess: null,
                addedSpaceMembersFailure: null,
            };
        case spaceTypes.ADD_SPACE_MEMBERS_SUCCESS:
            return {
                ...state,
                addingSpaceMembers: false,
                addedSpaceMembersSuccess: action.payload,
                addedSpaceMembersFailure: null,
            };
        case spaceTypes.ADD_SPACE_MEMBERS_FAILURE:
            return {
                ...state,
                addingSpaceMembers: false,
                addedSpaceMembersSuccess: null,
                addedSpaceMembersFailure: action.payload,
            };

        // Remove space member
        case spaceTypes.REMOVE_SPACE_MEMBER_REQUEST:
            return {
                ...state,
                removingSpaceMember: true,
                removedSpaceMemberSuccess: null,
                removedSpaceMemberFailure: null,
            };
        case spaceTypes.REMOVE_SPACE_MEMBER_SUCCESS:
            return {
                ...state,
                removingSpaceMember: false,
                removedSpaceMemberSuccess: action.payload,
                removedSpaceMemberFailure: null,
            };
        case spaceTypes.REMOVE_SPACE_MEMBER_FAILURE:
            return {
                ...state,
                removingSpaceMember: false,
                removedSpaceMemberSuccess: null,
                removedSpaceMemberFailure: action.payload,
            };

        // Add space guests
        case spaceTypes.ADD_SPACE_GUESTS_REQUEST:
            return {
                ...state,
                addingSpaceGuests: true,
                addedSpaceGuestsSuccess: null,
                addedSpaceGuestsFailure: null,
            };
        case spaceTypes.ADD_SPACE_GUESTS_SUCCESS:
            return {
                ...state,
                addingSpaceGuests: false,
                addedSpaceGuestsSuccess: action.payload,
                addedSpaceGuestsFailure: null,
            };
        case spaceTypes.ADD_SPACE_GUESTS_FAILURE:
            return {
                ...state,
                addingSpaceGuests: false,
                addedSpaceGuestsSuccess: null,
                addedSpaceGuestsFailure: action.payload,
            };

        // Remove space guest
        case spaceTypes.REMOVE_SPACE_GUEST_REQUEST:
            return {
                ...state,
                removingSpaceGuest: true,
                removedSpaceGuestSuccess: null,
                removedSpaceGuestFailure: null,
            };
        case spaceTypes.REMOVE_SPACE_GUEST_SUCCESS:
            return {
                ...state,
                removingSpaceGuest: false,
                removedSpaceGuestSuccess: action.payload,
                removedSpaceGuestFailure: null,
            };
        case spaceTypes.REMOVE_SPACE_GUEST_FAILURE:
            return {
                ...state,
                removingSpaceGuest: false,
                removedSpaceGuestSuccess: null,
                removedSpaceGuestFailure: action.payload,
            };

        // Space guest accept
        case spaceTypes.SPACE_GUEST_ACCEPT_REQUEST:
            return {
                ...state,
                spaceGuestAccepting: true,
                spaceGuestAcceptedSuccess: null,
                spaceGuestAcceptedFailure: null,
            };
        case spaceTypes.SPACE_GUEST_ACCEPT_SUCCESS:
            return {
                ...state,
                spaceGuestAccepting: false,
                spaceGuestAcceptedSuccess: action.payload,
                spaceGuestAcceptedFailure: null,
            };
        case spaceTypes.SPACE_GUEST_ACCEPT_FAILURE:
            return {
                ...state,
                spaceGuestAccepting: false,
                spaceGuestAcceptedSuccess: null,
                spaceGuestAcceptedFailure: action.payload,
            };

        // Space guest login
        case spaceTypes.SPACE_GUEST_LOGIN_REQUEST:
            return {
                ...state,
                spaceGuestLoggingIn: true,
                spaceGuestLoggedInSuccess: null,
                spaceGuestLoggedInFailure: null,
            };
        case spaceTypes.SPACE_GUEST_LOGIN_SUCCESS:
            return {
                ...state,
                spaceGuestLoggingIn: false,
                spaceGuestLoggedInSuccess: action.payload,
                spaceGuestLoggedInFailure: null,
            };
        case spaceTypes.SPACE_GUEST_LOGIN_FAILURE:
            return {
                ...state,
                spaceGuestLoggingIn: false,
                spaceGuestLoggedInSuccess: null,
                spaceGuestLoggedInFailure: action.payload,
            };

        // Space guest token verify
        case spaceTypes.SPACE_GUEST_TOKEN_VERIFY_REQUEST:
            return {
                ...state,
                spaceGuestTokenVerifying: true,
                spaceGuestTokenVerifiedSuccess: null,
                spaceGuestTokenVerifiedFailure: null,
            };
        case spaceTypes.SPACE_GUEST_TOKEN_VERIFY_SUCCESS:
            return {
                ...state,
                spaceGuestTokenVerifying: false,
                spaceGuestTokenVerifiedSuccess: action.payload,
                spaceGuestTokenVerifiedFailure: null,
            };
        case spaceTypes.SPACE_GUEST_TOKEN_VERIFY_FAILURE:
            return {
                ...state,
                spaceGuestTokenVerifying: false,
                spaceGuestTokenVerifiedSuccess: null,
                spaceGuestTokenVerifiedFailure: action.payload,
            };

        // Get space guest invite preview
        case spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_REQUEST:
            return {
                ...state,
                gettingSpaceGuestInvitePreview: true,
                gotSpaceGuestInvitePreviewSuccess: null,
                gotSpaceGuestInvitePreviewFailure: null,
            };
        case spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_SUCCESS:
            return {
                ...state,
                gettingSpaceGuestInvitePreview: false,
                gotSpaceGuestInvitePreviewSuccess: action.payload,
                gotSpaceGuestInvitePreviewFailure: null,
            };
        case spaceTypes.GET_SPACE_GUEST_INVITE_PREVIEW_FAILURE:
            return {
                ...state,
                gettingSpaceGuestInvitePreview: false,
                gotSpaceGuestInvitePreviewSuccess: null,
                gotSpaceGuestInvitePreviewFailure: action.payload,
            };

        // Get space guest brands
        case spaceTypes.GET_SPACE_GUEST_BRANDS_REQUEST:
            return {
                ...state,
                gettingSpaceGuestBrands: true,
                gotSpaceGuestBrandsSuccess: null,
                gotSpaceGuestBrandsFailure: null,
            };
        case spaceTypes.GET_SPACE_GUEST_BRANDS_SUCCESS:
            return {
                ...state,
                gettingSpaceGuestBrands: false,
                gotSpaceGuestBrandsSuccess: action.payload,
                gotSpaceGuestBrandsFailure: null,
            };
        case spaceTypes.GET_SPACE_GUEST_BRANDS_FAILURE:
            return {
                ...state,
                gettingSpaceGuestBrands: false,
                gotSpaceGuestBrandsSuccess: null,
                gotSpaceGuestBrandsFailure: action.payload,
            };

        // Leave space
        case spaceTypes.LEAVE_SPACE_REQUEST:
            return {
                ...state,
                leavingSpace: true,
                leftSpaceSuccess: null,
                leftSpaceFailure: null,
            };
        case spaceTypes.LEAVE_SPACE_SUCCESS:
            return {
                ...state,
                leavingSpace: false,
                leftSpaceSuccess: action.payload,
                leftSpaceFailure: null,
            };
        case spaceTypes.LEAVE_SPACE_FAILURE:
            return {
                ...state,
                leavingSpace: false,
                leftSpaceSuccess: null,
                leftSpaceFailure: action.payload,
            };

        // Reset actions
        case spaceTypes.RESET_FETCH_SINGLE_SPACE:
            return {
                ...state,
                fetchingSingleSpace: false,
                fetchedSingleSpaceSuccess: null,
                fetchedSingleSpaceFailure: null,
            };
        case spaceTypes.RESET_FETCH_SPACES:
            return {
                ...state,
                fetchingSpaces: false,
                fetchedSpacesSuccess: null,
                fetchedSpacesFailure: null,
            };
        case spaceTypes.RESET_CREATE_SPACE:
            return {
                ...state,
                creatingSpace: false,
                createdSpaceSuccess: null,
                createdSpaceFailure: null,
            };
        case spaceTypes.RESET_UPDATE_SPACE:
            return {
                ...state,
                updatingSpace: false,
                updatedSpaceSuccess: null,
                updatedSpaceFailure: null,
            };
        case spaceTypes.RESET_DELETE_SPACE:
            return {
                ...state,
                deletingSpace: false,
                deletedSpaceSuccess: null,
                deletedSpaceFailure: null,
            };
        case spaceTypes.RESET_PIN_SPACE:
            return {
                ...state,
                pinningSpace: false,
                pinnedSpaceSuccess: null,
                pinnedSpaceFailure: null,
            };
        case spaceTypes.RESET_UNPIN_SPACE:
            return {
                ...state,
                unpinningSpace: false,
                unpinnedSpaceSuccess: null,
                unpinnedSpaceFailure: null,
            };
        case spaceTypes.RESET_ARCHIVE_SPACE:
            return {
                ...state,
                archivingSpace: false,
                archivedSpaceSuccess: null,
                archivedSpaceFailure: null,
            };
        case spaceTypes.RESET_UNARCHIVE_SPACE:
            return {
                ...state,
                unarchivingSpace: false,
                unarchivedSpaceSuccess: null,
                unarchivedSpaceFailure: null,
            };
        case spaceTypes.RESET_ADD_SPACE_MEMBERS:
            return {
                ...state,
                addingSpaceMembers: false,
                addedSpaceMembersSuccess: null,
                addedSpaceMembersFailure: null,
            };
        case spaceTypes.RESET_REMOVE_SPACE_MEMBER:
            return {
                ...state,
                removingSpaceMember: false,
                removedSpaceMemberSuccess: null,
                removedSpaceMemberFailure: null,
            };
        case spaceTypes.RESET_ADD_SPACE_GUESTS:
            return {
                ...state,
                addingSpaceGuests: false,
                addedSpaceGuestsSuccess: null,
                addedSpaceGuestsFailure: null,
            };
        case spaceTypes.RESET_REMOVE_SPACE_GUEST:
            return {
                ...state,
                removingSpaceGuest: false,
                removedSpaceGuestSuccess: null,
                removedSpaceGuestFailure: null,
            };
        case spaceTypes.RESET_SPACE_GUEST_ACCEPT:
            return {
                ...state,
                spaceGuestAccepting: false,
                spaceGuestAcceptedSuccess: null,
                spaceGuestAcceptedFailure: null,
            };
        case spaceTypes.RESET_SPACE_GUEST_LOGIN:
            return {
                ...state,
                spaceGuestLoggingIn: false,
                spaceGuestLoggedInSuccess: null,
                spaceGuestLoggedInFailure: null,
            };
        case spaceTypes.RESET_SPACE_GUEST_TOKEN_VERIFY:
            return {
                ...state,
                spaceGuestTokenVerifying: false,
                spaceGuestTokenVerifiedSuccess: null,
                spaceGuestTokenVerifiedFailure: null,
            };
        case spaceTypes.RESET_GET_SPACE_GUEST_INVITE_PREVIEW:
            return {
                ...state,
                gettingSpaceGuestInvitePreview: false,
                gotSpaceGuestInvitePreviewSuccess: null,
                gotSpaceGuestInvitePreviewFailure: null,
            };
        case spaceTypes.RESET_GET_SPACE_GUEST_BRANDS:
            return {
                ...state,
                gettingSpaceGuestBrands: false,
                gotSpaceGuestBrandsSuccess: null,
                gotSpaceGuestBrandsFailure: null,
            };
        case spaceTypes.RESET_LEAVE_SPACE:
            return {
                ...state,
                leavingSpace: false,
                leftSpaceSuccess: null,
                leftSpaceFailure: null,
            };

        // Space Messages
        // Fetch space messages
        case spaceTypes.FETCH_SPACE_MESSAGES_REQUEST:
            return {
                ...state,
                fetchingSpaceMessages: true,
                fetchedSpaceMessagesSuccess: null,
                fetchedSpaceMessagesFailure: null,
            };
        case spaceTypes.FETCH_SPACE_MESSAGES_SUCCESS:
            return {
                ...state,
                fetchingSpaceMessages: false,
                fetchedSpaceMessagesSuccess: action.payload,
                fetchedSpaceMessagesFailure: null,
            };
        case spaceTypes.FETCH_SPACE_MESSAGES_FAILURE:
            return {
                ...state,
                fetchingSpaceMessages: false,
                fetchedSpaceMessagesSuccess: null,
                fetchedSpaceMessagesFailure: action.payload,
            };

        // Send space message
        case spaceTypes.SEND_SPACE_MESSAGE_REQUEST:
            return {
                ...state,
                sendingSpaceMessage: true,
                sentSpaceMessageSuccess: null,
                sentSpaceMessageFailure: null,
            };
        case spaceTypes.SEND_SPACE_MESSAGE_SUCCESS:
            return {
                ...state,
                sendingSpaceMessage: false,
                sentSpaceMessageSuccess: action.payload,
                sentSpaceMessageFailure: null,
            };
        case spaceTypes.SEND_SPACE_MESSAGE_FAILURE:
            return {
                ...state,
                sendingSpaceMessage: false,
                sentSpaceMessageSuccess: null,
                sentSpaceMessageFailure: action.payload,
            };

        // Pin space message
        case spaceTypes.PIN_SPACE_MESSAGE_REQUEST:
            return {
                ...state,
                pinningSpaceMessage: true,
                pinnedSpaceMessageSuccess: null,
                pinnedSpaceMessageFailure: null,
            };
        case spaceTypes.PIN_SPACE_MESSAGE_SUCCESS:
            return {
                ...state,
                pinningSpaceMessage: false,
                pinnedSpaceMessageSuccess: action.payload,
                pinnedSpaceMessageFailure: null,
            };
        case spaceTypes.PIN_SPACE_MESSAGE_FAILURE:
            return {
                ...state,
                pinningSpaceMessage: false,
                pinnedSpaceMessageSuccess: null,
                pinnedSpaceMessageFailure: action.payload,
            };

        // Unpin space message
        case spaceTypes.UNPIN_SPACE_MESSAGE_REQUEST:
            return {
                ...state,
                unpinningSpaceMessage: true,
                unpinnedSpaceMessageSuccess: null,
                unpinnedSpaceMessageFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_MESSAGE_SUCCESS:
            return {
                ...state,
                unpinningSpaceMessage: false,
                unpinnedSpaceMessageSuccess: action.payload,
                unpinnedSpaceMessageFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_MESSAGE_FAILURE:
            return {
                ...state,
                unpinningSpaceMessage: false,
                unpinnedSpaceMessageSuccess: null,
                unpinnedSpaceMessageFailure: action.payload,
            };

        // Edit space message
        case spaceTypes.EDIT_SPACE_MESSAGE_REQUEST:
            return {
                ...state,
                editingSpaceMessage: true,
                editedSpaceMessageSuccess: null,
                editedSpaceMessageFailure: null,
            };
        case spaceTypes.EDIT_SPACE_MESSAGE_SUCCESS:
            return {
                ...state,
                editingSpaceMessage: false,
                editedSpaceMessageSuccess: action.payload,
                editedSpaceMessageFailure: null,
            };
        case spaceTypes.EDIT_SPACE_MESSAGE_FAILURE:
            return {
                ...state,
                editingSpaceMessage: false,
                editedSpaceMessageSuccess: null,
                editedSpaceMessageFailure: action.payload,
            };

        // Delete space message
        case spaceTypes.DELETE_SPACE_MESSAGE_REQUEST:
            return {
                ...state,
                deletingSpaceMessage: true,
                deletedSpaceMessageSuccess: null,
                deletedSpaceMessageFailure: null,
            };
        case spaceTypes.DELETE_SPACE_MESSAGE_SUCCESS:
            return {
                ...state,
                deletingSpaceMessage: false,
                deletedSpaceMessageSuccess: action.payload,
                deletedSpaceMessageFailure: null,
            };
        case spaceTypes.DELETE_SPACE_MESSAGE_FAILURE:
            return {
                ...state,
                deletingSpaceMessage: false,
                deletedSpaceMessageSuccess: null,
                deletedSpaceMessageFailure: action.payload,
            };

        // Space Message Reset Actions
        case spaceTypes.RESET_FETCH_SPACE_MESSAGES:
            return {
                ...state,
                fetchingSpaceMessages: false,
                fetchedSpaceMessagesSuccess: null,
                fetchedSpaceMessagesFailure: null,
            };
        case spaceTypes.RESET_SEND_SPACE_MESSAGE:
            return {
                ...state,
                sendingSpaceMessage: false,
                sentSpaceMessageSuccess: null,
                sentSpaceMessageFailure: null,
            };
        case spaceTypes.RESET_PIN_SPACE_MESSAGE:
            return {
                ...state,
                pinningSpaceMessage: false,
                pinnedSpaceMessageSuccess: null,
                pinnedSpaceMessageFailure: null,
            };
        case spaceTypes.RESET_UNPIN_SPACE_MESSAGE:
            return {
                ...state,
                unpinningSpaceMessage: false,
                unpinnedSpaceMessageSuccess: null,
                unpinnedSpaceMessageFailure: null,
            };
        case spaceTypes.RESET_EDIT_SPACE_MESSAGE:
            return {
                ...state,
                editingSpaceMessage: false,
                editedSpaceMessageSuccess: null,
                editedSpaceMessageFailure: null,
            };
        case spaceTypes.RESET_DELETE_SPACE_MESSAGE:
            return {
                ...state,
                deletingSpaceMessage: false,
                deletedSpaceMessageSuccess: null,
                deletedSpaceMessageFailure: null,
            };
        case spaceTypes.CREATE_SPACE_FILE_REQUEST:
            return {
                ...state,
                creatingSpaceFile: true,
                createSpaceFileSuccess: null,
                createSpaceFileFailure: null,
            };
        case spaceTypes.CREATE_SPACE_FILE_SUCCESS:
            return {
                ...state,
                creatingSpaceFile: false,
                createSpaceFileSuccess: action.payload,
                createSpaceFileFailure: null,
            };
        case spaceTypes.CREATE_SPACE_FILE_FAILURE:
            return {
                ...state,
                creatingSpaceFile: false,
                createSpaceFileSuccess: null,
                createSpaceFileFailure: action.payload,
            };
        case spaceTypes.GET_SPACE_FILES_REQUEST:
            return {
                ...state,
                gettingSpaceFiles: true,
                getSpaceFilesSuccess: null,
                getSpaceFilesFailure: null,
            };
        case spaceTypes.GET_SPACE_FILES_SUCCESS:
            return {
                ...state,
                gettingSpaceFiles: false,
                getSpaceFilesSuccess: action.payload,
                getSpaceFilesFailure: null,
            };
        case spaceTypes.GET_SPACE_FILES_FAILURE:
            return {
                ...state,
                gettingSpaceFiles: false,
                getSpaceFilesSuccess: null,
                getSpaceFilesFailure: action.payload,
            };
        case spaceTypes.DELETE_SPACE_FILE_REQUEST:
            return {
                ...state,
                deletingSpaceFile: true,
                deleteSpaceFileSuccess: null,
                deleteSpaceFileFailure: null,
            };
        case spaceTypes.DELETE_SPACE_FILE_SUCCESS:
            return {
                ...state,
                deletingSpaceFile: false,
                deleteSpaceFileSuccess: action.payload,
                deleteSpaceFileFailure: null,
            };
        case spaceTypes.DELETE_SPACE_FILE_FAILURE:
            return {
                ...state,
                deletingSpaceFile: false,
                deleteSpaceFileSuccess: null,
                deleteSpaceFileFailure: action.payload,
            };
        case spaceTypes.GET_SINGLE_SPACE_FILE_REQUEST:
            return {
                ...state,
                gettingSingleSpaceFile: true,
                getSingleSpaceFileSuccess: null,
                getSingleSpaceFileFailure: null,
            };
        case spaceTypes.GET_SINGLE_SPACE_FILE_SUCCESS:
            return {
                ...state,
                gettingSingleSpaceFile: false,
                getSingleSpaceFileSuccess: action.payload,
                getSingleSpaceFileFailure: null,
            };
        case spaceTypes.GET_SINGLE_SPACE_FILE_FAILURE:
            return {
                ...state,
                gettingSingleSpaceFile: false,
                getSingleSpaceFileSuccess: null,
                getSingleSpaceFileFailure: action.payload,
            };
        case spaceTypes.CREATE_SPACE_NOTE_REQUEST:
            return {
                ...state,
                creatingSpaceNote: true,
                createSpaceNoteSuccess: null,
                createSpaceNoteFailure: null,
            };
        case spaceTypes.CREATE_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                creatingSpaceNote: false,
                createSpaceNoteSuccess: action.payload,
                createSpaceNoteFailure: null,
            };
        case spaceTypes.CREATE_SPACE_NOTE_FAILURE:
            return {
                ...state,
                creatingSpaceNote: false,
                createSpaceNoteSuccess: null,
                createSpaceNoteFailure: action.payload,
            };
        case spaceTypes.UPDATE_SPACE_NOTE_REQUEST:
            return {
                ...state,
                updatingSpaceNote: true,
                updateSpaceNoteSuccess: null,
                updateSpaceNoteFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                updatingSpaceNote: false,
                updateSpaceNoteSuccess: action.payload,
                updateSpaceNoteFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_NOTE_FAILURE:
            return {
                ...state,
                updatingSpaceNote: false,
                updateSpaceNoteSuccess: null,
                updateSpaceNoteFailure: action.payload,
            };
        case spaceTypes.FETCH_SPACE_NOTES_REQUEST:
            return {
                ...state,
                fetchingSpaceNotes: true,
                fetchSpaceNotesSuccess: null,
                fetchSpaceNotesFailure: null,
            };
        case spaceTypes.FETCH_SPACE_NOTES_SUCCESS:
            return {
                ...state,
                fetchingSpaceNotes: false,
                fetchSpaceNotesSuccess: action.payload,
                fetchSpaceNotesFailure: null,
            };
        case spaceTypes.FETCH_SPACE_NOTES_FAILURE:
            return {
                ...state,
                fetchingSpaceNotes: false,
                fetchSpaceNotesSuccess: null,
                fetchSpaceNotesFailure: action.payload,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_NOTE_REQUEST:
            return {
                ...state,
                fetchingSingleSpaceNote: true,
                fetchSingleSpaceNoteSuccess: null,
                fetchSingleSpaceNoteFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                fetchingSingleSpaceNote: false,
                fetchSingleSpaceNoteSuccess: action.payload,
                fetchSingleSpaceNoteFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_NOTE_FAILURE:
            return {
                ...state,
                fetchingSingleSpaceNote: false,
                fetchSingleSpaceNoteSuccess: null,
                fetchSingleSpaceNoteFailure: action.payload,
            };
        case spaceTypes.DELETE_SPACE_NOTE_REQUEST:
            return {
                ...state,
                deletingSpaceNote: true,
                deleteSpaceNoteSuccess: null,
                deleteSpaceNoteFailure: null,
            };
        case spaceTypes.DELETE_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                deletingSpaceNote: false,
                deleteSpaceNoteSuccess: action.payload,
                deleteSpaceNoteFailure: null,
            };
        case spaceTypes.DELETE_SPACE_NOTE_FAILURE:
            return {
                ...state,
                deletingSpaceNote: false,
                deleteSpaceNoteSuccess: null,
                deleteSpaceNoteFailure: action.payload,
            };
        case spaceTypes.PIN_SPACE_NOTE_REQUEST:
            return {
                ...state,
                pinningSpaceNote: true,
                pinSpaceNoteSuccess: null,
                pinSpaceNoteFailure: null,
            };
        case spaceTypes.PIN_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                pinningSpaceNote: false,
                pinSpaceNoteSuccess: action.payload,
                pinSpaceNoteFailure: null,
            };
        case spaceTypes.PIN_SPACE_NOTE_FAILURE:
            return {
                ...state,
                pinningSpaceNote: false,
                pinSpaceNoteSuccess: null,
                pinSpaceNoteFailure: action.payload,
            };
        case spaceTypes.UNPIN_SPACE_NOTE_REQUEST:
            return {
                ...state,
                unpinningSpaceNote: true,
                unpinSpaceNoteSuccess: null,
                unpinSpaceNoteFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_NOTE_SUCCESS:
            return {
                ...state,
                unpinningSpaceNote: false,
                unpinSpaceNoteSuccess: action.payload,
                unpinSpaceNoteFailure: null,
            };
        case spaceTypes.UNPIN_SPACE_NOTE_FAILURE:
            return {
                ...state,
                unpinningSpaceNote: false,
                unpinSpaceNoteSuccess: null,
                unpinSpaceNoteFailure: action.payload,
            };

        // Space Tasks
        case spaceTypes.FETCH_SPACE_TASKS_REQUEST:
            return {
                ...state,
                fetchingSpaceTasks: true,
                fetchedSpaceTasksSuccess: null,
                fetchedSpaceTasksFailure: null,
            };
        case spaceTypes.FETCH_SPACE_TASKS_SUCCESS:
            return {
                ...state,
                fetchingSpaceTasks: false,
                fetchedSpaceTasksSuccess: action.payload,
                fetchedSpaceTasksFailure: null,
            };
        case spaceTypes.FETCH_SPACE_TASKS_FAILURE:
            return {
                ...state,
                fetchingSpaceTasks: false,
                fetchedSpaceTasksSuccess: null,
                fetchedSpaceTasksFailure: action.payload,
            };

        case spaceTypes.FETCH_SINGLE_SPACE_TASK_REQUEST:
            return {
                ...state,
                fetchingSingleSpaceTask: true,
                fetchedSingleSpaceTaskSuccess: null,
                fetchedSingleSpaceTaskFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_TASK_SUCCESS:
            return {
                ...state,
                fetchingSingleSpaceTask: false,
                fetchedSingleSpaceTaskSuccess: action.payload,
                fetchedSingleSpaceTaskFailure: null,
            };
        case spaceTypes.FETCH_SINGLE_SPACE_TASK_FAILURE:
            return {
                ...state,
                fetchingSingleSpaceTask: false,
                fetchedSingleSpaceTaskSuccess: null,
                fetchedSingleSpaceTaskFailure: action.payload,
            };

        case spaceTypes.CREATE_SPACE_TASK_REQUEST:
            return {
                ...state,
                creatingSpaceTask: true,
                createdSpaceTaskSuccess: null,
                createdSpaceTaskFailure: null,
            };
        case spaceTypes.CREATE_SPACE_TASK_SUCCESS:
            return {
                ...state,
                creatingSpaceTask: false,
                createdSpaceTaskSuccess: action.payload,
                createdSpaceTaskFailure: null,
            };
        case spaceTypes.CREATE_SPACE_TASK_FAILURE:
            return {
                ...state,
                creatingSpaceTask: false,
                createdSpaceTaskSuccess: null,
                createdSpaceTaskFailure: action.payload,
            };

        case spaceTypes.UPDATE_SPACE_TASK_REQUEST:
            return {
                ...state,
                updatingSpaceTask: true,
                updatedSpaceTaskSuccess: null,
                updatedSpaceTaskFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_TASK_SUCCESS:
            return {
                ...state,
                updatingSpaceTask: false,
                updatedSpaceTaskSuccess: action.payload,
                updatedSpaceTaskFailure: null,
            };
        case spaceTypes.UPDATE_SPACE_TASK_FAILURE:
            return {
                ...state,
                updatingSpaceTask: false,
                updatedSpaceTaskSuccess: null,
                updatedSpaceTaskFailure: action.payload,
            };

        case spaceTypes.DELETE_SPACE_TASK_REQUEST:
            return {
                ...state,
                deletingSpaceTask: true,
                deletedSpaceTaskSuccess: null,
                deletedSpaceTaskFailure: null,
            };
        case spaceTypes.DELETE_SPACE_TASK_SUCCESS:
            return {
                ...state,
                deletingSpaceTask: false,
                deletedSpaceTaskSuccess: action.payload,
                deletedSpaceTaskFailure: null,
            };
        case spaceTypes.DELETE_SPACE_TASK_FAILURE:
            return {
                ...state,
                deletingSpaceTask: false,
                deletedSpaceTaskSuccess: null,
                deletedSpaceTaskFailure: action.payload,
            };

        // Space Task Reset Actions
        case spaceTypes.RESET_FETCH_SPACE_TASKS:
            return {
                ...state,
                fetchingSpaceTasks: false,
                fetchedSpaceTasksSuccess: null,
                fetchedSpaceTasksFailure: null,
            };
        case spaceTypes.RESET_FETCH_SINGLE_SPACE_TASK:
            return {
                ...state,
                fetchingSingleSpaceTask: false,
                fetchedSingleSpaceTaskSuccess: null,
                fetchedSingleSpaceTaskFailure: null,
            };
        case spaceTypes.RESET_CREATE_SPACE_TASK:
            return {
                ...state,
                creatingSpaceTask: false,
                createdSpaceTaskSuccess: null,
                createdSpaceTaskFailure: null,
            };
        case spaceTypes.RESET_UPDATE_SPACE_TASK:
            return {
                ...state,
                updatingSpaceTask: false,
                updatedSpaceTaskSuccess: null,
                updatedSpaceTaskFailure: null,
            };
        case spaceTypes.RESET_DELETE_SPACE_TASK:
            return {
                ...state,
                deletingSpaceTask: false,
                deletedSpaceTaskSuccess: null,
                deletedSpaceTaskFailure: null,
            };
        case spaceTypes.FETCH_SPACE_TASKS_RUNS_REQUEST:
            return {
                ...state,
                fetchingSpaceTasksRuns: true,
                fetchedSpaceTasksRunsSuccess: null,
                fetchedSpaceTasksRunsFailure: null,
            };
        case spaceTypes.FETCH_SPACE_TASKS_RUNS_SUCCESS:
            return {
                ...state,
                fetchingSpaceTasksRuns: false,
                fetchedSpaceTasksRunsSuccess: action.payload,
                fetchedSpaceTasksRunsFailure: null,
            };
        case spaceTypes.FETCH_SPACE_TASKS_RUNS_FAILURE:
            return {
                ...state,
                fetchingSpaceTasksRuns: false,
                fetchedSpaceTasksRunsSuccess: null,
                fetchedSpaceTasksRunsFailure: action.payload,
            };
        case spaceTypes.FETCH_SPACE_UNREAD_COUNT_REQUEST:
            return {
                ...state,
                fetchingSpaceUnreadCount: true,
                fetchedSpaceUnreadCountSuccess: null,
                fetchedSpaceUnreadCountFailure: null,
            };
        case spaceTypes.FETCH_SPACE_UNREAD_COUNT_SUCCESS:
            return {
                ...state,
                fetchingSpaceUnreadCount: false,
                fetchedSpaceUnreadCountSuccess: action.payload,
                fetchedSpaceUnreadCountFailure: null,
            };
        case spaceTypes.FETCH_SPACE_UNREAD_COUNT_FAILURE:
            return {
                ...state,
                fetchingSpaceUnreadCount: false,
                fetchedSpaceUnreadCountSuccess: null,
                fetchedSpaceUnreadCountFailure: action.payload,
            };
        default:
            return state;
    }
};
